export const StProc = ({ props }) => ([
  { text: 'Ja', value: '::true' },
  { text: 'Nein', value: '::false' },
])
